<app-header [selectedMenu]="MENU_PAGE.BBS_NOTICE"></app-header>

<div class="container">

  <div class="wrapper">

    <aside class="rope"></aside>
    <app-back-btn></app-back-btn>


    <section class="legal-notice">

      <div class="inner wrap">


        <div class="setting-box">


          <article class="book-layout">

            <div class="book-layout-wrap type-page-list-none">

              <div class="book-page-list">

                <div class="book-page-group">

                  <div class="page-box">
                    <div class="page-content scroll-effect over-y">
                      <div class="fixed-text"
                           *ngIf="fixedMsg">
                        <div class="fixed-msg"
                             [innerHTML]="fixedMsg.content | keepHtml">
                        </div>
                      </div>

                      <div *ngIf="is_loading; else articleLoaded"
                           class="loading-box">

                        <img src="assets/img/loading_icon.gif">
                      </div>

                      <ng-template #articleLoaded>
                        <div class="list-wrap" *ngIf="adminMsg; else noMessage">
                          <div class="admin-title"
                               [innerHTML]="adminMsg.title | keepHtml">
                          </div>
                          <div class="admin-des-box"
                               [innerHTML]="adminMsg.content | keepHtml">
                          </div>
                        </div>
                      </ng-template>
                      <ng-template #noMessage>
                        <div class="admin-des-box">
                          <br>운영자의 말이 없습니다.
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </article>

        </div>

      </div>
    </section>

  </div>

  <!-- app-footer></app-footer -->

</div>
